import template from './currency.create.html';
import controller from './currency.create.controller';
import './currency.create.scss';

let currencycreateComponent = {
  restrict: 'E',
  bindings: {
    hasACL: '='
  },
  template,
  controller
};

export default currencycreateComponent;



// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/currency/create/currency.create.component.js